import tw from 'twin.macro';

export const Wrapper = tw.div` w-full flex flex-col justify-center items-center pb-[7rem] gap-5 bg-softGray`;
export const ChaseHeader = tw.div`w-full  h-[28.625rem] p-4 flex flex-col justify-center items-center rounded-b-3xl gap-6 bg-pageBg`;

export const ChaseNav = tw.div`w-full flex items-start gap-4`;

export const ChaseContent = tw.div`w-full max-w-[25.875rem] pl-4 flex flex-col items-start justify-center gap-3`;
export const ContentSwipe = tw.div`w-full h-full [&>div]:h-[10rem]`;
export const ContentCard = tw.div`w-full pr-4 z-10`;

export const BackButton = tw.button`
 flex flex-col justify-center items-center w-10 h-10
 bg-yellow border-2 border-darkGray rounded-full
`;
